var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopmodalIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 27.532c-.096-.03-1.762-.592-1.805-.602a6.165 6.165 0 0 1-8.149 0l-1.797.602a4.182 4.182 0 0 0-2.86 3.927c.004.205-.022 2.014.03 2.172a1.68 1.68 0 0 0 1.621 1.352c3.59.003 13.878-.001 14.168 0a1.654 1.654 0 0 0 1.65-1.65v-1.836a4.182 4.182 0 0 0-2.859-3.965z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.868 26.438c3.077 2.094 7.548-.34 7.464-4.087a4.882 4.882 0 0 0-4.86-4.862c-4.824-.002-6.663 6.394-2.604 8.949z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 16.946A13.222 13.222 0 0 0 17.243 5.125c-17.757.65-17.294 26.254.218 26.334a5.474 5.474 0 0 1 3.735-5.143l1.267-.422c-3.684-5.271 2.213-11.974 7.912-8.948zm-12.492 1.388a.64.64 0 0 1-.192.454l-5.399 5.405a.643.643 0 0 1-.908-.909l5.22-5.213v-9.87a.64.64 0 0 1 1.279 0v10.133z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopmodalIcon2);
export default __webpack_public_path__ + "static/media/stopmodal-icon2.04e5abe41dd7d0a3dbb2305f2a0e774e.svg";
export { ForwardRef as ReactComponent };